<template>
<div class="HelpPage">
  <header-component></header-component>
   <help-article></help-article>
  
   <help-contact></help-contact>
   <help-info></help-info>
  <footer-component></footer-component>
</div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import HelpArticle from "@/components/portal/helpData/HelpArticle";
// import HelpBlock from "@/components/portal/helpData/HelpBlock";
import HelpContact from "@/components/portal/helpData/HelpContact";
import HelpInfo from "@/components/portal/helpData/HelpInfo";
export default {
  components: {HeaderComponent, 
               FooterComponent,
               HelpArticle,
               HelpContact,
               HelpInfo
              },
  data () {
  return {
  }
},
  methods: {
  },
  created() {
     localStorage.setItem('is-active','help');
  }
}
</script>


// WEBPACK FOOTER //
// Help.vue?08b016e9